import React from "react";
import { FaMicrophoneSlash } from "react-icons/fa6";

export default function MuteComponent() {
  return (
    <>
      <div
        style={{
          fontSize: "clamp(16px, 4vw, 25px)",
          position: "absolute",
          top: "3%",
          left: "3%",
          width: "clamp(32px, 8vw, 48px)",
          height: "clamp(32px, 8vw, 48px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          borderRadius: "50%",
          cursor: "pointer",
          zIndex: 5,
          backgroundColor: "#ff4343",
        }}
      >
        <FaMicrophoneSlash />
      </div>
    </>
  );
}
